import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { AdminService } from "app/services/admin/admin.service";
import { SharedService } from "app/services/core/shared.service";



@Component({
  selector: 'app-printRenewalForms',
  templateUrl: './printRenewalForms.component.html',
})

export class PrintRenewalFormsComponent implements OnInit {

  type = '';
  stateNumbers = '';

  formGroup = new UntypedFormGroup({
    StateNumbers: new UntypedFormControl('', [Validators.maxLength(4000)]),
    LicenseType: new UntypedFormControl('', [Validators.required])
  });

  constructor(public adminService: AdminService,
    public sharedService: SharedService,
    private datePipe: DatePipe) { };

  ngOnInit(): void {
  }

  print() {
    if (this.formGroup.valid) {
      let form = this.formGroup.value;
      this.type = form.LicenseType;
      this.stateNumbers = form.StateNumbers;
      this.adminService.printRenewalForms(this.type, this.stateNumbers).subscribe(
        res => {
          if (res.type == 'text/plain') {
            alert('No renewals found!');
          }
          else {
            this.downloadFile("LabRenewals-" + this.datePipe.transform(new Date(), 'yyyy-MM-dd'), res);
          }
        },
        error => console.log('error', error),
        () => {
        }
      );
    };
  }

  downloadFile(fileName: string, blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement('a');
    fileDownload.href = file;
    fileDownload.download = fileName;
    fileDownload.click();
  }

  tabVisible(type: string): boolean {
    // TODO
    return true;
  }

  typeChange() {
    this.type = this.formGroup.controls['LicenseType'].value;
  }

}
